import { Modal } from 'react-bootstrap';
import React from 'react'
import PortletBody from '../../../app/components/portlet/PortletBody';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import { StyledLabel } from '../../Campaigns/CampaignDetails';
import theme from '../../../utils/themes';
import { useGetProductsAgainstJobboardQuery } from '../../Products/productApiSlice';
import { useParams } from 'react-router-dom';

const DisconnectJobboardModal = ({ show, onHide, deleteJob, loading, data }) => {
      const { compId } = useParams();
     const { data: products,isLoading:pLoading} = useGetProductsAgainstJobboardQuery(
        {
          compId: compId,
          accessKey: data?.jobBoard?.accessKey
        },
        {
          refetchOnMountOrArgChange: true,
        },
      );
    return (
        <Modal show={show} centered onHide={onHide} size={'lg'}>
            <Modal.Header
                title="Delete Job"
                closeButton
                className="border-bottom-0 fs-5 pb-0 align-items-center mb-3 ps-2"
            >
                <Modal.Title
                    as="h4"
                    className="flex-grow-1 p-2 fs-2 cursor-pointer flex-center font-fredoka fw-normal"
                >
                    Disconnect {data?.jobBoard?.title}?
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex  flex-column bg-body rounded">
                <PortletBody className="p-0 w-100">
                    <PortletBody className={'p-0 w-100'}>
                       {!pLoading && <div className="p-4">
                            <StyledLabel size='16px' weight={500} color={theme?.headingColor}>
                                You are about to disconnect Indeed as a Job Board from your account.
                                
                                {products?.products?.length > 0 && `The following products currently rely on this integration and may stop working as expected:`}
                            </StyledLabel>
                         
                            
<StyledLabel size='16px' weight={500} color={theme?.headingColor} className={`${products?.products?.length > 0 ? 'mt-2' : ''}`}>
<ul>
    {products?.products?.map((item)=>(
    <li>{item?.title}</li>
    ))}
</ul>
</StyledLabel>

                            <StyledLabel size='16px' weight={500} color={theme?.headingColor}>
                             Once disconnected these features will no longer sync or display data from indeed and any automation or workflows connected to this service will be paused. 

                            </StyledLabel>
                            <StyledLabel size='16px' weight={500} color={theme?.headingColor} className='mt-3'>
Please review your setup before proceeding to avoid interruptions.
                            </StyledLabel>
                        </div>}
                        {pLoading && <div className='d-flex justify-content-center align-items-center p-4'> 
                            <span
        className={`spinner spinner-border spinner-border-sm d-inline-block`}
        style={{
          transition: 'all 0.3s linear',
        }}
      /></div>}
                    </PortletBody>
                </PortletBody>
             {!pLoading &&   <div className="d-flex justify-content-end mt-3">
                    <div className="d-flex gap-3">
                        <StyledButton
                            variant={'white'}
                            className="mb-2 fw-bold"
                            onClick={onHide}
                            disabled={loading}
                        >
                            Cancel
                        </StyledButton>
                        <StyledButton className="mb-2 border-0"
                        variant='primary'
                            disabled={loading}
                            loading={loading}
                            onClick={deleteJob}>
                            Confirm
                        </StyledButton>
                    </div>
                </div>}
            </Modal.Body>
        </Modal>
    )
}

export default DisconnectJobboardModal